export default {
  init() {
    $('.results-col').each(function() {
      var $col = $(this);
      // var $results = $col.find('.search-card');
      var $hiddenResults = $col.find('.search-card.d-none');

      if ($hiddenResults.length) {
        var $moreBtn = $col.find('.btn-more');
        $moreBtn.removeClass('d-none');

        $moreBtn.on('click', function() {
          $hiddenResults.removeClass('d-none');
          $moreBtn.addClass('d-none');
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search-results.js